import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { KPI_STATUS, KPI_STATUS_OPTIONS } from '../../useKPIService';
import { CustomBadge } from 'framework/ui/ui-builder';

const KpiStatusBadge = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const value = getValue() as any;

  const text = KPI_STATUS_OPTIONS[value];

  const getColor = () => {
    if (value === KPI_STATUS.INACTIVE) {
      return 'error';
    }

    return 'success';
  };

  return <CustomBadge text={text} color={getColor()} {...props} />;
};

export default KpiStatusBadge;
